var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification"},[_c('h6',[_vm._v(_vm._s(_vm.status))]),_c('button',{on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.desc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }